import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzureAuthenticationComponent } from './azure-authentication.component';
import {ArmFormModule} from '../../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {MaterialModule} from '../../../material.module';
import {FormsModule} from '@angular/forms';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [AzureAuthenticationComponent],
    imports: [
        CommonModule,
        ArmFormModule,
        ArmFormTitleModule,
        MaterialModule,
        FormsModule,
        ClipboardModule,
        InfraModule
    ]
})
export class AzureAuthenticationModule { }
